import React, { useEffect, useState } from "react";
import {
    AutocompleteInput,
    SaveButton, SimpleForm, TextInput, Toolbar, Edit, required, ReferenceInput, useEditController
} from "react-admin";
import { Box, Button, Divider, Grid, ThemeProvider, Typography } from "@mui/material";
import CustomDeleteButton from "./CustomDeleteButton";
import { useNavigate } from 'react-router-dom'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import PeopleIcon from '@mui/icons-material/People';
import Color from "../layout/color/Color";
import theme from "../layout/theme/Theme";
import FontSize from "../layout/FontSize";

const RoleList = [
    {
        id: 1,
        name: 'Master Manager',
    },
    {
        id: 2,
        name: 'Manager'
    },
    {
        id: 3,
        name: 'Cashier'
    }
]

const verifyButton = {
    bgcolor: Color.Main,
    borderRadius: '30px',
    border: '1px solid Color.Main',
    fontWeight: '500',
    textAlign: 'center',
    padding: '8px 15px',
    transition: '0.3s',
    fontSize: FontSize.Medium,
    textTransform: 'none',
    '&:hover': { background: Color.Button, color: Color.Normal }
  };
  
  const backButton = {
    bgcolor: Color.Button,
    borderRadius: '30px',
    border: "1px solid #055C2D",
    color: Color.Main,
    fontWeight: '500',
    textAlign: 'center',
    padding: '8px 15px',
    transition: '0.3s',
    fontSize: FontSize.Medium,
    textTransform: 'none',
    '&:hover': { background: Color.Main, color: Color.Button }
  };

const EmployeeCreateToolbar = (props) => {
    const navigate = useNavigate();
    const handleBack = (e) => {
        e.preventDefault();
        navigate('/Employee')
    }
    return (
        <Toolbar sx={{ justifyContent: 'space-between'}} {...props}>
            <Button
                startIcon={<KeyboardBackspaceIcon />}
                onClick={handleBack}
                sx={backButton}
            >
                Back
            </Button>
            <SaveButton sx={verifyButton}/>
        </Toolbar>
    )
}

export const EmployeeEdit = (props) => {
    const record = useEditController(props)
    const data = record.record
    const [roles, setRoles] = useState(RoleList);
    useEffect(() => {
        if (data !== undefined) {
            if (data.role === 1 || data.role === '1') {
                setRoles(RoleList);
            } else {
                if (data.role === 2 || data.role === '2') {
                    setRoles(RoleList.slice(1));
                } else {
                    setRoles(RoleList.slice(2))
                }
            }
        }
    }, [data]);

    return (
        <ThemeProvider theme={theme}>
         <Edit {...props}>
            <SimpleForm toolbar={<EmployeeCreateToolbar />}>
                <Grid sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', mb:2 }}>
                    <Button endIcon={<PeopleIcon  sx={{ color: Color.Main}}/>} sx={{ textAlign: 'left', ml: 1, cursor: 'default' }} size="medium">
                        <Typography variant="h3">
                            Edit Employee
                        </Typography>
                    </Button>
                    <CustomDeleteButton />
                </Grid>
                <Divider sx={{ width: '100%', mb: 2 }} />
                <Grid sx={{ display: 'flex', p: 3, width: '100%', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                    <Grid container={true} sx={{ alignItems: 'center', justifyContent: 'center', width: { xs: '100%', md: '80%' } }}>
                        <Grid item xs={12} md={8} lg={10} sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Box sx={{ width: { xs: '100%', md: '80%', lg: '50%' } }}>
                                <ReferenceInput source="submerchantID" reference="SubMerchant" >
                                    <AutocompleteInput source="submerchantID" optionText="name" label="SubMerchant name"></AutocompleteInput>
                                </ReferenceInput>
                            </Box>
                        </Grid>
                        <Divider sx={{ width: '100%' }} />
                        <Grid item xs={12} sx={{ p: 3 }}>
                            <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                    <Box>
                                        <TextInput disabled required source="username" label="Username" fullWidth variant="outlined" />
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Box>
                                        <TextInput required source="fullname" label="Fullname" fullWidth variant="outlined" />
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Box>
                                        <TextInput required source="address" label="Address" fullWidth variant="outlined" />
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Box>
                                        <TextInput required source="phone" label="Phone number" fullWidth variant="outlined" />
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Box>
                                        <TextInput required source="email" label="Email" fullWidth variant="outlined" />
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Box>
                                        <AutocompleteInput
                                            source="role"
                                            choices={roles}
                                            validate={required()}
                                            variant="outlined"
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </SimpleForm>
        </Edit>

        </ThemeProvider>
       
    )
}